<template>
  <v-card>
    <div class="password-recovering security-card-content">
      <div class="step-back-container">
        <v-icon color="#333333" size="22" @click="$emit('goBackStep')">
          mdi-arrow-left
        </v-icon>
      </div>

      <h2 class="check-email-title">
        {{ $i18n.t("passwordRecovering.title") }}
      </h2>

      <p class="check-email-text">
        {{ $i18n.t('passwordRecovering.text') }}
      </p>

      <v-scale-transition>
        <ToastNotification :toastText="$i18n.t('passwordRecovering.errorMessage')" v-if="error" class="mb-5" />
      </v-scale-transition>

      <v-form class="email-form" v-model="valid">
        <v-text-field
          v-model="email"
          :rules="emailRules"
          @keyup.enter="resetSend"
          type="text"
          :placeholder="$i18n.t('passwordRecovering.placeholder')"
          outlined
          class="email-text-field"
          autocomplete="off"
          hide-details
        />
      </v-form>

      <NewButton
        :text="$i18n.t('base.nextStep')"
        :disabled="!valid"
        :loading="loading"
        @on-click="resetSend"
      />

      <div class="cancel-text" @click="$emit('closeDialog'); email = ''">
        Cancelar
      </div>
    </div>
  </v-card>
</template>

<script>
import NewButton from "../NewButton.vue";
import ToastNotification from "../ToastNotification.vue";

export default {
  name: "PasswordRecovering",

  data() {
    return {
      email: null,
      valid: true,
      loading: false,
      error: false,
      emailRules: [
        v => !!v || this.$i18n.t("register.registerForm.error.emailRequired"),
        v => /.+@.+\..+/.test(v) || this.$i18n.t("register.registerForm.error.emailRequired"),
      ],
    };
  },

  components: {
    NewButton,
    ToastNotification,
  },

  methods: {
    async resetSend() {
      this.loading = true;
      await this.$auth.recoverPassword(this.email.trim(), this.whenErrorCallback);
      this.loading = false;
    },

    whenErrorCallback(err) {
      if (err) {
        this.error = true;
      } else {
        this.$emit("recoverSuccess");
      }
    },
  },

};
</script>

<style lang="scss" scoped>

.email-form{
  margin-bottom: 40px;
}

</style>
